export default {
    userList: {
        method: 'POST',
        url: '/manage-system/staff/page',
        name: '分页查询职工',
    },
    userFreeze: {
        method: 'PUT',
        url: '/manage-system/staff/freeze/{id}',
        name: '冻结用户',
    },
    userUnfreeze: {
        method: 'PUT',
        url: '/manage-system/staff/unfreeze/{id}',
        name: '取消冻结',
    },
    addUser: {
        method: 'POST',
        url: '/manage-system/staff',
        name: '新增用户',
    },
    editUser: {
        method: 'PUT',
        url: '/manage-system/staff',
        name: '编辑用户',
    },
    userDetail: {
        method: 'GET',
        url: '/manage-system/staff/{id}',
        name: '用户详情',
    },
    resetPwd: {
        method: 'PUT',
        url: '/manage-system/staff/reset/{id}',
        name: '重置密码',
    },
    roleList: {
        method: 'POST',
        url: '/manage-system/role/page',
        name: '系统用户列表',
    },
    roleFreeze: {
        method: 'PUT',
        url: '/manage-system/role/freeze/{id}',
        name: '冻结角色',
    },
    roleUnfreeze: {
        method: 'PUT',
        url: '/manage-system/role/unfreeze/{id}',
        name: '冻结角色',
    },
    allPermission: {
        method: 'GET',
        url: '/manage-system/role/allPermission',
        name: '获得所有权限',
    },
    addRole: {
        method: 'POST',
        url: '/manage-system/role',
        name: '新增角色',
    },
    updateRole: {
        method: 'PUT',
        url: '/manage-system/role',
        name: '编辑角色',
    },
    getDetail: {
        method: 'GET',
        url: '/manage-system/role/{id}',
        name: '角色详情',
    },
    checkExist: {
        method: 'POST',
        url: '/manage-system/staff/checkExist',
        name: '重复账号校验',
    },
    password: {
        method: 'PUT',
        url: '/manage-system/staff/pass',
        name: '修改密码'
    },
    selectList: {
        method: 'GET',
        url: '/manage-system/role/listAll',
        name: '获取角色下拉列表',
    },
}
